import api from './api';

export const sampleCollectionService = {
  // Search registered and collected samples with multi-criteria filtering
  searchSamples: async (params = {}) => {
    const response = await api.get('/sample-collection/search', { params });
    return response.data;
  },

  // Get Phlebotomy counter metrics for workbench dashboard
  getSummary: async (params = {}) => {
    const response = await api.get('/sample-collection/summary', { params });
    return response.data;
  },

  // Retrieve detail of a specific specimen test item
  getSampleById: async (testId) => {
    const response = await api.get(`/sample-collection/${testId}`);
    return response.data;
  },

  // Collect one or more specimen tubes
  collectSamples: async (data) => {
    const response = await api.post('/sample-collection/collect', data);
    return response.data;
  },

  // Reject one or more specimens at phlebotomy (collection) stage
  rejectSamples: async (data) => {
    const response = await api.post('/sample-collection/reject', data);
    return response.data;
  },

  // Get rejection reason master list (shared with receive page)
  getRejectionReasons: async () => {
    const response = await api.get('/sample-receive/rejection-reasons');
    return response.data;
  },

  // Get today's collection-stage rejection log
  getRejectionLog: async (params = {}) => {
    const response = await api.get('/sample-collection/rejection-log', { params });
    return response.data;
  },
};

export default sampleCollectionService;
